module.exports = __webpack_public_path__ + "img/pause_dp.53f01653.svg";